//Check radio button on associated HTML elements click
$(".desk_modal_cancel_feedback_form-1 div[class^='radio_button-']").click(function () {
  //find associated input and set it to checked
  $(this).find('input:radio').prop('checked', true);
  //remove all active classes
  $("div[class^='radio_button-']").removeClass('active');
  //add active class to the element associated with the selected radio
  $(this).toggleClass('active');
});

//Display KeepMembership Modal when user clicks on 'Keep Membership' button
$(".desk_modal_cancel_feedback_form-1 .keepmembershipmodal").click(function (e) {
  $.ajax({
    type: 'GET',
    url: "/Account/KeepMembershipModal",
    success: function (data, status) {
      $("#myModal").html(data);
      $("#myModal").attr("aria-labelledby", "desk_cancel_page-keep");
    }
  });
});

//Form submit
$('.desk_modal_cancel_feedback_form-1 #feedbackForm').on('submit', function (e) {
  e.preventDefault();
  var form = $(this);
  var count = 0;
  //count the selected radio buttons
  $('input:radio').each(function() {
    if ($(this).is(':checked')) {
      count++;
    }
  });

  //the only validation we need is to have only one radio checked
  if (count === 1) {
    $.ajax({
      type: form.attr('method'),
      url: form.attr('action'),
      data: form.serialize(),
      success: function (data, status) {
        $target.html(data);
        $($form.attr("data-target")).attr("aria-labelledby", form.attr("data-label-for"));
      }
    });
  }
  else {
    $("#AlertError").show();
    return false;
  }
});
